import { GoArrowLeft  } from "react-icons/go";
import { CiLaptop ,CiGrid2H,CiRead ,CiCircleCheck    } from "react-icons/ci";
import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
export const Hf = () => {


    return (
        <div>
            <div className="relative isolate overflow-hidden bg-white  lg:overflow-visible lg:px-0">

                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8  lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
                    <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8">
                        <div className="lg:pr-4">
                            <div className="lg:max-w-lg">
                                <a href={"/company/integrations"} className="text-sm items-center flex font-semibold text-indigo-600"><GoArrowLeft className={"h-5 w-5 mr-2"}/>Zurück</a>
                                <h1 className="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 ">
                                    Home & Family - Plattform
                                </h1>
                                <p className="mt-6 text-sm text-gray-700">
                                    Die Plattform für Wohnprojekte und bewohnergetragene Genossenschaftsgründungen
                                    Die Home & Family Plattform verbindet kommunale Wohnungsbaukoordination mit Baupartnern in einem Projektraum. Die herstellerunabhängige Projektbegleitung beinhaltet zudem einen Prozessablauf zur Neugründung von sogen. Bewohnergetragenen Genossenschaften zur Schaffung von Wohnraum und Begleitung von Wohnraumförderung.
                                    <br/><br/>Lassen Sie sich beraten! Einfach Beratung anfragen unter <a className={"underline"} href={"mailTo:dialog@xplanung24.de"}>dialog@xplanung24.de</a>

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="-mt-12 -ml-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
                        <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/integrations/hf/mainImage.png`}
                            className="w-3xl  max-w-none border border-gray-500 bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-228"
                        />
                    </div>

                </div>
            </div>
        </div>
    )
}
